import { render, staticRenderFns } from "./DrawingPicture2Text.vue?vue&type=template&id=55a12407&scoped=true"
import script from "./DrawingPicture2Text.vue?vue&type=script&lang=js"
export * from "./DrawingPicture2Text.vue?vue&type=script&lang=js"
import style0 from "./DrawingPicture2Text.vue?vue&type=style&index=0&id=55a12407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a12407",
  null
  
)

export default component.exports